import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { FileAttachment } from "./fileAttachment"
import { AgreementType } from "../../agreement/constants/agreementType"

@Serializable
export class CustomerMainTaskSimpleListView {
  uid: string = ""
  name: string = ""
  description: string = ""
  ownerName: string = ""
  agreementType: number = AgreementType.Framework
  files: FileAttachment[] = []
  currency: string = ""

  constructor(
    data: {
      uid: string
      name: string
      description: string
      ownerName: string
      agreementType: number
      files: any[]
      currency: string
    } | null = null,
  ) {
    if (data) {
      this.uid = data.uid
      this.name = data.name
      this.description = data.description
      this.ownerName = data.ownerName
      this.agreementType = data.agreementType
      this.files = data.files
      this.currency = data.currency
    }
  }
}
